import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { forwardRef, useMemo } from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { Link, useHistory } from 'react-router-dom';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import SectionTitle from '../common/sectionTitle';
import DimensionItem from '../Specifications/DimensionItem';
import { Accordion, DownArrow, RichContent, Button, QuickLinkIcon } from '../../../../../components';
import classes from './csportaldetails.module.css';

var convertJsonString = function convertJsonString(str) {
  var result = false;

  try {
    result = JSON.parse(str);
  } catch (e) {
    return false;
  }

  return result;
};

var CSPortalDetails = forwardRef(function (props, ref) {
  var _hf_box_weight1$enter, _hf_box_weight2$enter, _hf_box_weight3$enter, _hf_box_weight1$enter2, _hf_box_weight1$enter3, _hf_box_weight2$enter2, _hf_box_weight2$enter3, _hf_box_weight3$enter2, _hf_box_weight3$enter3, _customAttributes$fin, _customAttributes$fin2, _csPOrtalDetailsCombi, _csPOrtalDetailsCombi2, _Object$keys, _Object$keys2, _customAttributes$fin3, _customAttributes$fin4, _replacementCanopy$se, _replacementCanopy$se2;

  var productDetails = props.productDetails,
      customAttributes = props.customAttributes,
      weight = props.weight,
      product = props.product,
      installationSheetUrl = props.installationSheetUrl,
      configCustomAttributes = props.configCustomAttributes,
      isOutletProduct = props.isOutletProduct;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;
  var history = useHistory();
  var hf_box_weight1 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight1';
  });
  var hf_box_weight2 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight2';
  });
  var hf_box_weight3 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight3';
  });
  var boxWeight = hf_box_weight1 && hf_box_weight1 !== null && hf_box_weight1 !== void 0 && (_hf_box_weight1$enter = hf_box_weight1.entered_attribute_value) !== null && _hf_box_weight1$enter !== void 0 && _hf_box_weight1$enter.value || hf_box_weight2 && hf_box_weight2 !== null && hf_box_weight2 !== void 0 && (_hf_box_weight2$enter = hf_box_weight2.entered_attribute_value) !== null && _hf_box_weight2$enter !== void 0 && _hf_box_weight2$enter.value || hf_box_weight3 && hf_box_weight3 !== null && hf_box_weight3 !== void 0 && (_hf_box_weight3$enter = hf_box_weight3.entered_attribute_value) !== null && _hf_box_weight3$enter !== void 0 && _hf_box_weight3$enter.value ? {
    label: 'Packed weight',
    value: (isNaN(parseFloat(hf_box_weight1 === null || hf_box_weight1 === void 0 ? void 0 : (_hf_box_weight1$enter2 = hf_box_weight1.entered_attribute_value) === null || _hf_box_weight1$enter2 === void 0 ? void 0 : _hf_box_weight1$enter2.value)) ? 0 : parseFloat(hf_box_weight1 === null || hf_box_weight1 === void 0 ? void 0 : (_hf_box_weight1$enter3 = hf_box_weight1.entered_attribute_value) === null || _hf_box_weight1$enter3 === void 0 ? void 0 : _hf_box_weight1$enter3.value)) + (isNaN(parseFloat(hf_box_weight2 === null || hf_box_weight2 === void 0 ? void 0 : (_hf_box_weight2$enter2 = hf_box_weight2.entered_attribute_value) === null || _hf_box_weight2$enter2 === void 0 ? void 0 : _hf_box_weight2$enter2.value)) ? 0 : parseFloat(hf_box_weight2 === null || hf_box_weight2 === void 0 ? void 0 : (_hf_box_weight2$enter3 = hf_box_weight2.entered_attribute_value) === null || _hf_box_weight2$enter3 === void 0 ? void 0 : _hf_box_weight2$enter3.value)) + (isNaN(parseFloat(hf_box_weight3 === null || hf_box_weight3 === void 0 ? void 0 : (_hf_box_weight3$enter2 = hf_box_weight3.entered_attribute_value) === null || _hf_box_weight3$enter2 === void 0 ? void 0 : _hf_box_weight3$enter2.value)) ? 0 : parseFloat(hf_box_weight3 === null || hf_box_weight3 === void 0 ? void 0 : (_hf_box_weight3$enter3 = hf_box_weight3.entered_attribute_value) === null || _hf_box_weight3$enter3 === void 0 ? void 0 : _hf_box_weight3$enter3.value)) + ' lbs',
    constructed_value: true
  } : null;
  var specValues = [];
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_part_num';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_smart_string';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_part_class';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_shipping_method';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_dim_weight';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_length1';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_width1';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_height1';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight1';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_length2';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_width2';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_height2';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight2';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_length3';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_width3';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_height3';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight3';
  }));
  specValues.push(boxWeight);
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_weight_class';
  })); // const mountingDirection = customAttributes?.find(
  //     attr => attr.attribute_metadata.code == 'hf_mounting_direction'
  // );
  // const mountingDirectionValues = mountingDirection?.selected_attribute_options?.attribute_option
  //     ?.map(option => option.label)
  //     ?.join(', ');
  // specValues.push(
  //     mountingDirection
  //         ? {
  //               label: mountingDirection?.attribute_metadata?.label,
  //               value: mountingDirectionValues,
  //               constructed_value: true
  //           }
  //         : null
  // );

  var replacementCanopy = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_replacement_canopy';
  }); // We still have to find out the format that this data will be given at, right now it looks like this:
  // an empty array of

  var csPortalDetails = convertJsonString((_customAttributes$fin = customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_csportal_details';
  })) === null || _customAttributes$fin === void 0 ? void 0 : (_customAttributes$fin2 = _customAttributes$fin.entered_attribute_value) === null || _customAttributes$fin2 === void 0 ? void 0 : _customAttributes$fin2.value);
  var csPOrtalDetailsCombined = useMemo(function () {
    var _ref, _csPortalDetails$Deta;

    return csPortalDetails !== null && csPortalDetails !== void 0 && csPortalDetails.DetailText ? (_ref = _toConsumableArray(csPortalDetails === null || csPortalDetails === void 0 ? void 0 : (_csPortalDetails$Deta = csPortalDetails.DetailText) === null || _csPortalDetails$Deta === void 0 ? void 0 : _csPortalDetails$Deta.map(function (item, idx) {
      return {
        name: csPortalDetails === null || csPortalDetails === void 0 ? void 0 : csPortalDetails.DetailType[idx],
        value: item
      };
    }))) === null || _ref === void 0 ? void 0 : _ref.reduce(function (acc, _ref2) {
      var _acc$name;

      var name = _ref2.name,
          value = _ref2.value;
      (_acc$name = acc[name]) !== null && _acc$name !== void 0 ? _acc$name : acc[name] = {
        name: name,
        value: []
      };
      if (Array.isArray(value)) acc[name].value = acc[name].value.concat(value);else acc[name].value.push(value);
      return acc;
    }, {}) : [];
  }, [csPortalDetails === null || csPortalDetails === void 0 ? void 0 : csPortalDetails.DetailText, csPortalDetails === null || csPortalDetails === void 0 ? void 0 : csPortalDetails.DetailType]);
  var itemFacts = csPOrtalDetailsCombined !== null && csPOrtalDetailsCombined !== void 0 && csPOrtalDetailsCombined['Item Facts'] ? React.createElement("div", {
    key: 'item-facts',
    className: classes.list
  }, React.createElement("h6", null, "Item Facts"), React.createElement("ul", null, csPOrtalDetailsCombined === null || csPOrtalDetailsCombined === void 0 ? void 0 : (_csPOrtalDetailsCombi = csPOrtalDetailsCombined['Item Facts']) === null || _csPOrtalDetailsCombi === void 0 ? void 0 : (_csPOrtalDetailsCombi2 = _csPOrtalDetailsCombi.value) === null || _csPOrtalDetailsCombi2 === void 0 ? void 0 : _csPOrtalDetailsCombi2.map(function (val) {
    return React.createElement("li", null, val);
  }))) : null;
  (_Object$keys = Object.keys(csPOrtalDetailsCombined)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (name, idx) {
    var _csPOrtalDetailsCombi3, _csPOrtalDetailsCombi4;

    if (name == 'Item Facts') return React.createElement("div", {
      key: 'item-fact-' + idx,
      className: classes.list
    }, React.createElement("h6", null, name), csPOrtalDetailsCombined === null || csPOrtalDetailsCombined === void 0 ? void 0 : (_csPOrtalDetailsCombi3 = csPOrtalDetailsCombined[name]) === null || _csPOrtalDetailsCombi3 === void 0 ? void 0 : (_csPOrtalDetailsCombi4 = _csPOrtalDetailsCombi3.value) === null || _csPOrtalDetailsCombi4 === void 0 ? void 0 : _csPOrtalDetailsCombi4.map(function (val) {
      var _csPOrtalDetailsCombi5, _csPOrtalDetailsCombi6;

      return React.createElement("ul", null, csPOrtalDetailsCombined === null || csPOrtalDetailsCombined === void 0 ? void 0 : (_csPOrtalDetailsCombi5 = csPOrtalDetailsCombined[name]) === null || _csPOrtalDetailsCombi5 === void 0 ? void 0 : (_csPOrtalDetailsCombi6 = _csPOrtalDetailsCombi5.value) === null || _csPOrtalDetailsCombi6 === void 0 ? void 0 : _csPOrtalDetailsCombi6.map(function (val) {
        return React.createElement("li", null, val);
      }));
    }));
  });
  var otherFacts = (_Object$keys2 = Object.keys(csPOrtalDetailsCombined)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.map(function (name, idx) {
    var _csPOrtalDetailsCombi7, _csPOrtalDetailsCombi8;

    if (name != 'Item Facts') return React.createElement("div", {
      key: 'other-fact-' + idx,
      className: classes.list
    }, React.createElement("h6", null, name), React.createElement("ul", null, csPOrtalDetailsCombined === null || csPOrtalDetailsCombined === void 0 ? void 0 : (_csPOrtalDetailsCombi7 = csPOrtalDetailsCombined[name]) === null || _csPOrtalDetailsCombi7 === void 0 ? void 0 : (_csPOrtalDetailsCombi8 = _csPOrtalDetailsCombi7.value) === null || _csPOrtalDetailsCombi8 === void 0 ? void 0 : _csPOrtalDetailsCombi8.map(function (val) {
      return React.createElement("li", null, val);
    })));
  });
  var shippingInfoContent = React.createElement("div", null, React.createElement("p", {
    className: "font-bold text-base mb-4"
  }, "Shipping Info"), React.createElement("div", {
    className: classes.shippingInfoWrapper
  }, React.createElement(DimensionItem, {
    key: product === null || product === void 0 ? void 0 : product.sku,
    measure: 'Item Nbr',
    value: product === null || product === void 0 ? void 0 : product.sku,
    isPdf: false
  }), specValues.filter(function (item) {
    var _item$entered_attribu, _item$selected_attrib, _item$selected_attrib2;

    return (item === null || item === void 0 ? void 0 : item.constructed_value) || (item === null || item === void 0 ? void 0 : (_item$entered_attribu = item.entered_attribute_value) === null || _item$entered_attribu === void 0 ? void 0 : _item$entered_attribu.value) || (item === null || item === void 0 ? void 0 : (_item$selected_attrib = item.selected_attribute_options) === null || _item$selected_attrib === void 0 ? void 0 : (_item$selected_attrib2 = _item$selected_attrib.attribute_option[0]) === null || _item$selected_attrib2 === void 0 ? void 0 : _item$selected_attrib2.label);
  }).map(function (specValue, idx) {
    if (!!specValue) {
      var _specValue$entered_at, _specValue$selected_a, _specValue$selected_a2, _specValue$attribute_, _specValue$attribute_2, _specValue$attribute_3, _specValue$attribute_4, _specValue$attribute_5;

      var attrVal = specValue !== null && specValue !== void 0 && specValue.constructed_value ? specValue === null || specValue === void 0 ? void 0 : specValue.value : (specValue === null || specValue === void 0 ? void 0 : (_specValue$entered_at = specValue.entered_attribute_value) === null || _specValue$entered_at === void 0 ? void 0 : _specValue$entered_at.value) || (specValue === null || specValue === void 0 ? void 0 : (_specValue$selected_a = specValue.selected_attribute_options) === null || _specValue$selected_a === void 0 ? void 0 : (_specValue$selected_a2 = _specValue$selected_a.attribute_option[0]) === null || _specValue$selected_a2 === void 0 ? void 0 : _specValue$selected_a2.label);

      if (specValue !== null && specValue !== void 0 && (_specValue$attribute_ = specValue.attribute_metadata) !== null && _specValue$attribute_ !== void 0 && (_specValue$attribute_2 = _specValue$attribute_.code) !== null && _specValue$attribute_2 !== void 0 && _specValue$attribute_2.includes('_weight') && (specValue === null || specValue === void 0 ? void 0 : (_specValue$attribute_3 = specValue.attribute_metadata) === null || _specValue$attribute_3 === void 0 ? void 0 : _specValue$attribute_3.code) !== 'hf_weight_class') {
        attrVal = attrVal + ' lbs';
      } else if (specValue !== null && specValue !== void 0 && (_specValue$attribute_4 = specValue.attribute_metadata) !== null && _specValue$attribute_4 !== void 0 && (_specValue$attribute_5 = _specValue$attribute_4.code) !== null && _specValue$attribute_5 !== void 0 && _specValue$attribute_5.includes('hf_box_')) {
        attrVal = attrVal + '"';
      }

      return React.createElement(DimensionItem, {
        key: idx,
        measure: specValue !== null && specValue !== void 0 && specValue.constructed_value ? specValue === null || specValue === void 0 ? void 0 : specValue.label : specValue.attribute_metadata.label,
        value: attrVal,
        isPdf: false
      });
    }
  })));
  var detailsContent = React.createElement("div", {
    className: "flex flex-col gap-3"
  }, otherFacts && React.createElement("div", {
    className: "md_w-[50%] md_mr-3"
  }, otherFacts), React.createElement("div", {
    className: "md_w-[50%] md_ml-3"
  }, itemFacts), React.createElement("div", null, React.createElement("p", {
    className: "font-bold text-base mb-4"
  }, "Process Doc"), React.createElement("div", {
    className: "mt-5"
  }, React.createElement("a", {
    target: "_blank",
    href: "http://hfintranet.vtforge.com/Mfg/Miscellaneous/ProcessDocs-E10.cfm"
  }, "Link to Process Doc")))); // We still have to find out the format that this data will be given at, right now it looks like this:
  // an empty array of

  var replacementRecommendedData = convertJsonString((_customAttributes$fin3 = customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_replacement_recommended';
  })) === null || _customAttributes$fin3 === void 0 ? void 0 : (_customAttributes$fin4 = _customAttributes$fin3.entered_attribute_value) === null || _customAttributes$fin4 === void 0 ? void 0 : _customAttributes$fin4.value);
  var rrData = useMemo(function () {
    var _replacementRecommend;

    return replacementRecommendedData !== null && replacementRecommendedData !== void 0 && replacementRecommendedData.ReplacementRecommendationCategory ? _toConsumableArray(replacementRecommendedData === null || replacementRecommendedData === void 0 ? void 0 : (_replacementRecommend = replacementRecommendedData.ReplacementRecommendationCategory) === null || _replacementRecommend === void 0 ? void 0 : _replacementRecommend.map(function (item, idx) {
      return {
        type: replacementRecommendedData === null || replacementRecommendedData === void 0 ? void 0 : replacementRecommendedData.ReplacementRecommendationType[idx],
        category: replacementRecommendedData === null || replacementRecommendedData === void 0 ? void 0 : replacementRecommendedData.ReplacementRecommendationCategory[idx],
        partNumber: replacementRecommendedData === null || replacementRecommendedData === void 0 ? void 0 : replacementRecommendedData.ReplacementRecommendationPartNumber[idx],
        notes: replacementRecommendedData === null || replacementRecommendedData === void 0 ? void 0 : replacementRecommendedData.ReplacementRecommendationNotes[idx]
      };
    })) : [];
  }, [replacementRecommendedData]);
  var replacementRecommended = React.createElement("div", {
    className: ""
  }, React.createElement("p", {
    className: "font-bold text-base mb-4"
  }, "Replacement Recommended"), React.createElement("div", {
    className: "mt-5 md_flex"
  }, React.createElement("div", {
    className: "md_w-[50%] md_mr-3"
  }, rrData.map(function (item, idx) {
    return React.createElement("div", {
      key: 'replacement-' + idx,
      className: classes.list
    }, React.createElement("h6", null, item.type), React.createElement("ul", null, (item === null || item === void 0 ? void 0 : item.category) && React.createElement("li", null, React.createElement("strong", null, "Category:"), " ", item.category), (item === null || item === void 0 ? void 0 : item.partNumber) && React.createElement("li", null, React.createElement("strong", null, "Part Number:"), " ", item.partNumber), (item === null || item === void 0 ? void 0 : item.notes) && React.createElement("li", null, React.createElement("strong", null, "Notes:"), " ", item.notes)));
  }), replacementCanopy && React.createElement("div", {
    key: 'replacement-canopy-attr',
    className: classes.list
  }, React.createElement("h6", null, "Replacement Canopy"), React.createElement("ul", null, React.createElement("li", null, React.createElement("strong", null, "Part Number:"), ' ', (_replacementCanopy$se = replacementCanopy.selected_attribute_options) === null || _replacementCanopy$se === void 0 ? void 0 : (_replacementCanopy$se2 = _replacementCanopy$se.attribute_option) === null || _replacementCanopy$se2 === void 0 ? void 0 : _replacementCanopy$se2[0].label))))));
  return React.createElement("div", {
    ref: ref,
    className: classes.root
  }, React.createElement("div", {
    className: "grid grid-cols-1 gap-4"
  }, React.createElement("div", {
    className: "col-span-1"
  }, shippingInfoContent), React.createElement("div", {
    className: "col-span-1"
  }, detailsContent), React.createElement("div", {
    className: "col-span-1"
  }, replacementRecommended)));
});
export default CSPortalDetails;